const onetrustDetect = () => {
  window.OptanonWrapper = function() {
    console.log('OneTrust has been loaded');    
    if (window.OneTrust && window.OnetrustActiveGroups) {
        // Access OneTrust groups
        const activeGroups = window.OnetrustActiveGroups;
        
        // Trigger your custom event
        const onetrustLoadedEvent = new CustomEvent('onetrustLoaded', {
            detail: { activeGroups }
        });
        document.dispatchEvent(onetrustLoadedEvent);
    }
  };
  document.addEventListener('onetrustLoaded', function(event) {
      // console.log('OneTrust loaded event received', event.detail);
      var privacyLinkElement = document.querySelector(".privacy-notice-link");

      if (privacyLinkElement) {
          var baseUrl = `https://${window.location.hostname}`;
          var path = window.location.pathname;

          if (path.startsWith("/institutional")) {
              privacyLinkElement.setAttribute("href", baseUrl + "/institutional/cookie-policy/");
          } else if (path.startsWith("/financial-advisor")) {
              privacyLinkElement.setAttribute("href", baseUrl + "/financial-advisor/cookie-policy/");
          } else if (path.startsWith("/individual")) {
              privacyLinkElement.setAttribute("href", baseUrl + "/individual/cookie-policy/");
          } else if (path.startsWith("/non-us")) {
              privacyLinkElement.setAttribute("href", baseUrl + "/non-us/cookie-policy/");
          } else {
              // privacyLinkElement.setAttribute("href", baseUrl + "/cookie-policy/");
          }
      }
  });
};

export default onetrustDetect;